import { hydrateReducer } from '@doda/common/src/redux/utils/hydrateReducer';
import { combineReducers } from '@reduxjs/toolkit';
import {
  memberInfoInitialState,
  memberInfoReducer,
} from '@doda/common/src/redux/features/memberInfo';
import {
  analyticsInitialState,
  analyticsReducer,
} from '@doda/common/src/redux/features/analytics';
import {
  queryParamsReducer,
  queryParamsInitialState,
} from '@doda/common/src/redux/features/queryParams';
import {
  masterInitialState,
  masterReducer,
} from '@doda/common/src/redux/features/master';
import {
  jobTrendRankingInitialState,
  jobTrendRankingReducer,
} from '@doda/common/src/redux/features/JobContent/JobTrend/jobTrendRanking';
import {
  jobTrendRecommendListInitialState,
  jobTrendRecommendListReducer,
} from '@doda/common/src/redux/features/JobContent/JobTrend/jobTrendRecommendList';
import {
  jobRecommendOffsetInitialState,
  jobRecommendOffsetReducer,
} from '@doda/common/src/redux/features/JobContent/JobTrend/jobRecommendOffset';
import {
  jobRecommendListForTrendEmployeeAverageAgeReducer,
  jobRecommendListForTrendEmployeeAverageAgeInitialState,
} from '@doda/common/src/redux/features/JobContent/JobTrend/jobRecommendListForTrendEmployeeAverageAge';
import {
  jobRecommendListForTrendEmploymentStatusReducer,
  jobRecommendListForTrendEmploymentStatusState,
} from '@doda/common/src/redux/features/JobContent/JobTrend/jobRecommendListForTrendEmploymentStatus';
import {
  jobRecommendListForTrendEstablishInitialState,
  jobRecommendListForTrendEstablishReducer,
} from '@doda/common/src/redux/features/JobContent/JobTrend/jobRecommendListForTrendEstablish';
import {
  jobRecommendListForTrendHolidayAndWayOfWorkingReducer,
  jobRecommendListForTrendHolidayAndWayOfWorkingInitialState,
} from '@doda/common/src/redux/features/JobContent/JobTrend/jobRecommendListForTrendHolidayAndWayOfWorking';
import {
  jobRecommendListForTrendLanguageAndPositionsReducer,
  jobRecommendListForTrendLanguageAndPositionsInitialState,
} from '@doda/common/src/redux/features/JobContent/JobTrend/jobRecommendListForTrendLanguageAndPositions';
import {
  jobRecommendListForTrendRequirementsReducer,
  jobRecommendListForTrendRequirementsInitialState,
} from '@doda/common/src/redux/features/JobContent/JobTrend/jobRecommendListForTrendRequirements';
import {
  jobRecommendListForTrendWelfareBenefitsReducer,
  jobRecommendListForTrendWelfareBenefitsInitialState,
} from '@doda/common/src/redux/features/JobContent/JobTrend/jobRecommendListForTrendWelfareBenefits';
import {
  jobRecommendListForTrendWorkplaceEnvironmentsReducer,
  jobRecommendListForTrendWorkplaceEnvironmentInitialState,
} from '@doda/common/src/redux/features/JobContent/JobTrend/jobRecommendListForTrendWorkplaceEnvironment1';
import {
  jobRecommendListForTrendIncomeReducer,
  jobRecommendListForTrendIncomeInitialState,
} from '@doda/common/src/redux/features/JobContent/JobTrend/jobRecommendListForTrendIncome';

const reducers = combineReducers({
  queryParams: queryParamsReducer,
  memberInfo: memberInfoReducer,
  analytics: analyticsReducer,
  master: masterReducer,
  jobTrendRanking: jobTrendRankingReducer,
  jobTrendRecommendList: jobTrendRecommendListReducer,
  jobRecommendOffset: jobRecommendOffsetReducer,
  jobRecommendListForTrendRequirements:
    jobRecommendListForTrendRequirementsReducer,
  jobRecommendListForTrendIncome: jobRecommendListForTrendIncomeReducer,
  jobRecommendListForTrendWorkplaceEnvironment:
    jobRecommendListForTrendWorkplaceEnvironmentsReducer,
  jobRecommendListForTrendHolidayAndWayOfWorking:
    jobRecommendListForTrendHolidayAndWayOfWorkingReducer,
  jobRecommendListForTrendEmployeeAverageAge:
    jobRecommendListForTrendEmployeeAverageAgeReducer,
  jobRecommendListForTrendEmploymentStatus:
    jobRecommendListForTrendEmploymentStatusReducer,
  jobRecommendListForTrendWelfareBenefits:
    jobRecommendListForTrendWelfareBenefitsReducer,
  jobRecommendListForTrendLanguageAndPositions:
    jobRecommendListForTrendLanguageAndPositionsReducer,
  jobRecommendListForTrendEstablish: jobRecommendListForTrendEstablishReducer,
});
const initialState = {
  queryParams: queryParamsInitialState,
  memberInfo: memberInfoInitialState,
  analytics: analyticsInitialState,
  master: masterInitialState,
  jobTrendRanking: jobTrendRankingInitialState,
  jobTrendRecommendList: jobTrendRecommendListInitialState,
  jobRecommendOffset: jobRecommendOffsetInitialState,
  jobRecommendListForTrendRequirements:
    jobRecommendListForTrendRequirementsInitialState,
  jobRecommendListForTrendIncome: jobRecommendListForTrendIncomeInitialState,
  jobRecommendListForTrendWorkplaceEnvironment:
    jobRecommendListForTrendWorkplaceEnvironmentInitialState,
  jobRecommendListForTrendHolidayAndWayOfWorking:
    jobRecommendListForTrendHolidayAndWayOfWorkingInitialState,
  jobRecommendListForTrendEmployeeAverageAge:
    jobRecommendListForTrendEmployeeAverageAgeInitialState,
  jobRecommendListForTrendEmploymentStatus:
    jobRecommendListForTrendEmploymentStatusState,
  jobRecommendListForTrendWelfareBenefits:
    jobRecommendListForTrendWelfareBenefitsInitialState,
  jobRecommendListForTrendLanguageAndPositions:
    jobRecommendListForTrendLanguageAndPositionsInitialState,
  jobRecommendListForTrendEstablish:
    jobRecommendListForTrendEstablishInitialState,
};

export const reducer = hydrateReducer(reducers, initialState);

export type JobTrendRootState = ReturnType<typeof reducer>;
